export enum DocsTable {
  NAME = 'Name',
  TYPE = 'Type',
  UPLOADED_BY = 'Uploaded By',
  TAGS = 'Tags',
  ACTIONS = 'Actions',
}
